<template>
  <div class="animated fadeIn mt-5">
    <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
      <div class="row">
        <b-col md="6">
          <b-card>
            <div slot="header">
              <strong>Campanha</strong>
            </div>

            <!-- Nome -->
            <b-form-row>
              <b-col md="6">
                <b-form-group label="Nome">
                  <b-form-input type="text" name="name" v-model="item.name" placeholder="Nome"
                                v-validate="'required'" :state="validateState('name')"></b-form-input>
                  <b-form-invalid-feedback>{{ errors.first('name') }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="Descrição APP">
                  <b-form-input type="text" name="description" v-model="item.description" placeholder="Descrição APP"
                                v-validate="'required'" :state="validateState('description')"></b-form-input>
                  <b-form-invalid-feedback>{{ errors.first('description') }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-form-row>

            <!-- Datas e Estado -->
            <b-form-row>
              <b-col md="4">
                <b-form-group label="Início">
                  <b-form-input type="number" step="1" min="201801" name="ym_start" v-model="item.ym_start"
                                placeholder="Início" v-validate="'required'" :state="validateState('ym_start')"></b-form-input>
                  <b-form-invalid-feedback>{{ errors.first('ym_start') }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Fim">
                  <b-form-input type="number" step="1" min="201801" name="ym_end" v-model="item.ym_end"
                                placeholder="Fim" v-validate="'required'" :state="validateState('ym_end')"></b-form-input>
                  <b-form-invalid-feedback>{{ errors.first('ym_end') }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Estado">
                  <b-form-select :options="stateOptions" name="state" v-model="item.state"
                                 placeholder="Estado" v-validate="'required'" :state="validateState('state')"></b-form-select>
                  <b-form-invalid-feedback>{{ errors.first('state') }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-form-row>

            <!-- Objectivos -->
            <b-form-row>
              <b-col md="4">
                <b-form-group label="Obj Valor">
                  <b-form-select :options="stateOptions" name="enable_value" v-model="item.enable_value"
                                 placeholder="Obj Valor" v-validate="'required'" :state="validateState('enable_value')"></b-form-select>
                  <b-form-invalid-feedback>{{ errors.first('enable_value') }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Obj Operadores">
                  <b-form-select :options="stateOptions" name="enable_operators" v-model="item.enable_operators"
                                 placeholder="Obj Operadores" v-validate="'required'" :state="validateState('enable_operators')"></b-form-select>
                  <b-form-invalid-feedback>{{ errors.first('enable_operators') }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Obj Qtd">
                  <b-form-select :options="stateOptions" name="enable_quantity" v-model="item.enable_quantity"
                                 placeholder="Obj Qtd" v-validate="'required'" :state="validateState('enable_quantity')"></b-form-select>
                  <b-form-invalid-feedback>{{ errors.first('enable_quantity') }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-form-row>

            <!-- Tipo da Campanha -->
            <b-form-row>
              <b-col md="4">
                <b-form-group label="Tipo da Campanha">
                  <b-form-select :options="campaignTypeOptions" name="campaign_type" v-model="item.campaign_type"
                                 placeholder="Tipo da Campanha" v-validate="'required'" :state="validateState('campaign_type')"></b-form-select>
                  <b-form-invalid-feedback>{{ errors.first('campaign_type') }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Success Margin (%)">
                  <b-form-input type="number" min="0" name="success_margin" v-model="item.success_margin"
                                placeholder="Success Margin"></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>

            <!-- NOVOS CAMPOS -->
            <hr>
            <h5>Materiais & Configurações</h5>
            <b-form-row>
              <b-col md="6">
                <b-form-group label="PDF Leaflets (URL)">
                  <b-form-input type="text" name="pdfleaflets" v-model="item.pdfleaflets"
                                placeholder="URL do PDF"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Imagem do PDF Leaflets (URL)">
                  <b-form-input type="text" name="image_pdfleaflets" v-model="item.image_pdfleaflets"
                                placeholder="URL da Imagem"></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col md="6">
                <b-form-group label="Single Sheets (URL)">
                  <b-form-input type="text" name="pdfsinglesheet" v-model="item.pdfsinglesheet"
                                placeholder="URL Single Sheets"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">

                <b-form-group label="Imagem Single Sheets (URL)">
                  <b-form-input type="text" name="image_singlesheets" v-model="item.image_singlesheets"
                                placeholder="URL da Imagem"></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>

            <!-- Multiplicadores -->
            <b-form-fieldset label="Multiplicador por objectivos cumpridos:">
              <b-form-row>
                <b-col md="4">
                  <b-form-group label="1 objectivo">
                    <b-form-input type="number" step="1" min="0" name="points_multiplier1"
                                  v-model="item.points_multiplier1"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col md="4">
                  <b-form-group label="2 objectivos">
                    <b-form-input type="number" step="1" min="0" name="points_multiplier2"
                                  v-model="item.points_multiplier2"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col md="4">
                  <b-form-group label="3 objectivos">
                    <b-form-input type="number" step="1" min="0" name="points_multiplier3"
                                  v-model="item.points_multiplier3"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
            </b-form-fieldset>

            <!-- Footer -->
            <div slot="footer">
              <div class="row">
                <div class="col-sm-3">
                  <router-link :to="{name:'bestof.index'}" size="sm" variant="danger">
                    <i class="fa fa-ban"></i> Cancelar
                  </router-link>
                </div>

                <div class="col-sm-9 text-right">
                  <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                  <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary">
                    <i class="fa fa-save"></i> Gravar e fechar
                  </b-button>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>

        <!-- Right column permanece igual -->
        <b-col md="6">
        </b-col>
      </div>
    </form>
  </div>
</template>

<script>
import Prodaggregs from '@/views/products/prodaggregs/modal.vue'
import lists from '@/components/States.js'

export default {
  name: 'BestofEdit',
  props: ['id'],
  components: { Prodaggregs },
  data() {
    return {
      importZoneObjectives: '',
      importDsrObjectives: '',
      importLeaderObjectives: '',
      importProdaggregs: '',
      prodaggregFields: [
        { key: 'id', label: 'Id' },
        { key: 'code', label: 'code' },
        { key: 'name', label: 'Name' },
        'index',
      ],
      stateOptions: lists.states,
      campaignTypeOptions: [],
      item: {
        name: '',
        desciption: '',
        state: 0,
        campaign_type: null,
        points_multiplier1: 1,
        points_multiplier2: 1,
        points_multiplier3: 1,
        enable_value: 0,
        enable_quantity: 0,
        enable_operators: 0,

        /* NOVOS CAMPOS */
        success_margin: 100,   
        pdfleaflets: '',
        image_pdfleaflets: '',
        pdfsinglesheet: '',
        image_singlesheets: '',

        objectives: { data: [] },
        dsrobjectives: { data: [] },
        leaderobjectives: { data: [] },
        prodaggregs: { data: [] }
      }
    }
  },

  methods: {
    fetchCampaignTypes() {
      this.axios.get('bestof/campaign-types-lst')
        .then(response => {
          this.campaignTypeOptions = response.data.map(c => ({ value: c.id, text: c.name }))
        })
        .catch(error => console.error('Erro ao carregar tipos de campanha', error))
    },

    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (result) { this.submit(evt, close); return }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },

    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },

    submit(e, close) {
      e.preventDefault()
      const data = {
        data: this.item,
        prodaggregs: this.importProdaggregs,
        zoneObjectives: this.importZoneObjectives,
        dsrObjectives: this.importDsrObjectives,
        leaderObjectives: this.importLeaderObjectives
      }

      const request = this.item.id
        ? this.axios.put(`bestof/campaigns/${this.item.id}`, data)
        : this.axios.post('bestof/campaigns', data)

      request.then(response => {
        this.item = response.data.data
        this.$bvToast.toast(`Item gravado com sucesso`, { autoHideDelay: 5000 })
        if (close || !this.item.id) {
          this.$router.push({ name: close ? 'bestof.index' : 'bestof.edit', params: { id: this.item.id } })
        }
      }).catch(() => {
        this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000 })
      })
    }
  },

  created() {
    this.fetchCampaignTypes()

    const id = this.$route.params.id
    if (id) {
      this.axios.get(`bestof/campaigns/${id}`)
        .then(response => { this.item = response.data.data })
        .catch(() => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({ name: 'bestof.index' })
        })
    }
  }
}
</script>
